/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useStore } from '.';
import { selectPagesPaths } from './selectors';

export const usePagesPaths = (spaceID: string) => useStore(selectPagesPaths(spaceID));
